// extracted by mini-css-extract-plugin
export default {"tooltip":"businessProvince_tooltip__2cCSz","tooltipRow":"businessProvince_tooltipRow__zKkB0"};